let timeline = [
  {
    id: 1,
    title: "The Triwizard Tournament",
    description:
      "Unleash your technical mind and explore your searching skills. Find the problem, then wrap it up and climb the rounds. Isn't it simple?",
    buttonText: "View Frontend Projects",
    date: "28th Feb 2022",
    icon: "work",
  },
  {
    id: 2,
    title: "Chamber of Secrets",
    description:
      "Unravel the mystery and join the broken pieces to move ahead in the game. Patch the logic to complete the story.",
    buttonText: "View Backend Projects",
    date: "1st March 2022",
    icon: "work",
  },
  {
    id: 3,
    title: "Weasly’s Pitchers",
    description:
      "We present you with a pitching war filled with imaginative ideas to compete. Showcase your creativity and boast with your speaking skills.",
      buttonText: "Company Website",
    date: "3rd March 2022",
    icon: "work",
  },
]

export default timeline;